module.exports = __webpack_public_path__ + "img/SuccessTurtle.9e2d7b97.png";